<template>
    <div class="container">
        <!-- <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item> <i class="iconfont icon--shebei"></i> 设备列表 </el-breadcrumb-item>
                <el-breadcrumb-item>设备详情</el-breadcrumb-item>
            </el-breadcrumb>
        </div> -->
        <div>
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span class="deviceBaseInfoTitle">基本信息</span>
                    <div style="float: right; padding: 3px 0" type="text">
                        <el-button class="ml10" type="primary"
                            @click="limitVisible = true, limitTitle = '设置ph最大值'">设置ph最大值</el-button>
                        <el-button class="ml10" type="primary"
                            @click="limitVisible = true, limitTitle = '设置ph最小值'">设置ph最小值</el-button>
                        <el-button class="ml10" type="primary" v-if="!hasCOD"
                            @click="limitVisible = true, limitTitle = '设置cod阈值'">设置cod阈值</el-button>
                        <el-button class="ml10" type="primary"
                            @click="limitVisible = true, limitTitle = '设置ec阈值'">设置ec阈值</el-button>
                        <el-button class="ml10" type="primary"
                            @click="limitVisible = true, limitTitle = '设置水位阈值'">设置水位阈值</el-button>
                        <el-button class="ml10" type="primary" v-if="companyId == 1"
                            @click="limitVisible = true, limitTitle = '设置井深'">设置井深</el-button>
                        <el-button class="ml10" type="primary" v-if="companyId == 1"
                            @click="limitVisible = true, limitTitle = '设置管长'">设置管长</el-button>
                        <el-button class="ml10" type="primary" v-if="companyId == 1"
                            @click="limitVisible = true, limitTitle = '设置标高'">设置标高</el-button>

                        <el-button class="ml10" type="primary" @click="pushTaskVisible = true">下发工单</el-button>

                        <el-button class="ml10" type="primary" @click="editLocationF">修改经纬度信息</el-button>
                        <el-button class="ml10" type="primary" @click="changeMaintain">{{
                                deviceDeatil.maintain == '0' ? '加入维护' : '解除维护'
                            }}</el-button>
                    </div>
                </div>

                <div class="deviceBaseInfoContent">
                    <el-container>
                        <el-main>
                            <el-row>
                                <el-col :span="6">
                                    <div class="grid-content bg-purple-light">
                                        <div class="infoBox">
                                            <div class="infolabel">设备名称:</div>
                                            <div class="infoValue">{{ deviceDeatil.deviceName }}</div>
                                        </div>
                                    </div>
                                </el-col>

                                <el-col :span="6">
                                    <div class="grid-content bg-purple-light">
                                        <div class="infoBox">
                                            <div class="infolabel">设备别名:</div>
                                            <div class="infoValue">
                                                {{ deviceDeatil.anotherName ? deviceDeatil.anotherName : '未设置' }}
                                            </div>
                                        </div>
                                    </div>
                                </el-col>

                                <el-col :span="6">
                                    <div class="grid-content bg-purple">
                                        <div class="infoBox">
                                            <div class="infolabel">维护状态:</div>
                                            <div class="infoValue">
                                                <el-tag effect="dark"
                                                    :type="deviceDeatil.maintain == '0' ? 'success' : 'warning'">{{
                                deviceDeatil.maintain == '0' ? '正常' : '维护中'
                            }}</el-tag>
                                            </div>
                                        </div>
                                    </div>
                                </el-col>

                                <el-col :span="6">
                                    <div class="grid-content bg-purple-light">
                                        <div class="infoBox">
                                            <div class="infolabel">创建时间:</div>
                                            <div class="infoValue">{{ deviceDeatil.createtime }}</div>
                                        </div>
                                    </div>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="6">
                                    <div class="grid-content bg-purple-light">
                                        <div class="infoBox">
                                            <div class="infolabel">更新时间:</div>
                                            <div class="infoValue">{{ deviceDeatil.updatetime }}</div>
                                        </div>
                                    </div>
                                </el-col>
                                <!-- <el-col :span="6">
                                    <div class="grid-content bg-purple-light">
                                        <div class="infoBox">
                                            <div class="infolabel">IMSI_HIGH:</div>
                                            <div class="infoValue">{{ deviceDeatil.imsih }}</div>
                                        </div>
                                    </div>
                                </el-col>
                                <el-col :span="6">
                                    <div class="grid-content bg-purple">
                                        <div class="infoBox">
                                            <div class="infolabel">IMSI_LOW:</div>
                                            <div class="infoValue">{{ deviceDeatil.imsil }}</div>
                                        </div>
                                    </div>
                                </el-col> -->
                                <el-col :span="6">
                                    <div class="grid-content bg-purple-light">
                                        <div class="infoBox">
                                            <div class="infolabel">经度:</div>
                                            <div class="infoValue">{{ deviceDeatil.latitude ? deviceDeatil.latitude :
                                '未设置'
                                                }}</div>
                                        </div>
                                    </div>
                                </el-col>
                                <el-col :span="6">
                                    <div class="grid-content bg-purple-light">
                                        <div class="infoBox">
                                            <div class="infolabel">纬度:</div>
                                            <div class="infoValue">{{ deviceDeatil.longitude ? deviceDeatil.longitude :
                                '未设置' }}</div>
                                        </div>
                                    </div>
                                </el-col>
                                <el-col :span="6">
                                    <div class="grid-content bg-purple-light">
                                        <div class="infoBox">
                                            <div class="infolabel">设备图片:</div>
                                            <div class="infoValue">
                                                <el-button @click.native="showImgPriverFunc"
                                                    type="primary">查看</el-button>
                                                <el-image-viewer v-if="showImgPriver" :on-close="hidImgPriverFunc"
                                                    :url-list="[deviceDeatil.imgSrc]" />
                                            </div>
                                        </div>
                                    </div>
                                </el-col>
                            </el-row>
                            <el-row>

                                <el-col :span="6">
                                    <div class="grid-content bg-purple-light">
                                        <div class="infoBox">
                                            <div class="infolabel">设备类型:</div>
                                            <div class="infoValue">{{ deviceDeatil.deviceType }}</div>
                                        </div>
                                    </div>
                                </el-col>
                                <el-col :span="6">
                                    <div class="grid-content bg-purple-light">
                                        <div class="infoBox">
                                            <div class="infolabel">设备位置:</div>
                                            <div class="infoValue">{{ deviceDeatil.address }}</div>
                                        </div>
                                    </div>
                                </el-col>
                                <el-col :span="4" v-if="projectId !== 'SDjsjc'">
                                    <div class="grid-content bg-purple-light">
                                        <div class="infoBox">
                                            <div class="infolabel">软件版本:</div>
                                            <div class="infoValue">{{ deviceDeatil.software }}</div>
                                        </div>
                                    </div>
                                </el-col>
                            </el-row>
                            <el-row>

                                <el-col :span="6">
                                    <div class="grid-content bg-purple-light">
                                        <div class="infoBox">
                                            <div class="infolabel">井深:</div>
                                            <div class="infoValue">{{ deviceDeatil.deep ? (deviceDeatil.deep + ' m') :
                                '未设置'
                                                }}
                                            </div>
                                        </div>
                                    </div>
                                </el-col>
                                <el-col :span="6">
                                    <div class="grid-content bg-purple-light">
                                        <div class="infoBox">
                                            <div class="infolabel">管长:</div>
                                            <div class="infoValue">{{ deviceDeatil.tie ? (deviceDeatil.tie + ' m') :
                                '未设置'
                                                }}
                                            </div>
                                        </div>
                                    </div>
                                </el-col>
                                <el-col :span="6" v-if="projectId !== 'SDjsjc'">
                                    <div class="grid-content bg-purple-light">
                                        <div class="infoBox">
                                            <div class="infolabel">标高:</div>
                                            <div class="infoValue">{{ deviceDeatil.sHight + ' m'
                                                }}</div>
                                        </div>
                                    </div>
                                </el-col>

                            </el-row>
                            <el-row>

                                <el-col :span="6">
                                    <div class="grid-content bg-purple-light">
                                        <div class="infoBox">
                                            <div class="infolabel">PH最大阈值:</div>
                                            <div class="infoValue">{{ deviceDeatil.phLimitMax ? deviceDeatil.phLimitMax
                                :
                                '未设置'
                                                }}
                                            </div>
                                        </div>
                                    </div>
                                </el-col>
                                <el-col :span="6">
                                    <div class="grid-content bg-purple-light">
                                        <div class="infoBox">
                                            <div class="infolabel">PH最小阈值:</div>
                                            <div class="infoValue">{{ deviceDeatil.phLimitMin ? deviceDeatil.phLimitMin
                                :
                                '未设置'
                                                }}
                                            </div>
                                        </div>
                                    </div>
                                </el-col>
                                <el-col :span="6" v-if="projectId !== 'SDjsjc'">
                                    <div class="grid-content bg-purple-light">
                                        <div class="infoBox">
                                            <div class="infolabel">ec阈值:</div>
                                            <div class="infoValue">{{ deviceDeatil.ecLimit ? deviceDeatil.ecLimit :
                                '未设置'
                                                }}</div>
                                        </div>
                                    </div>
                                </el-col>
                                <el-col :span="6" v-if="projectId !== 'SDjsjc' && !hasCOD">
                                    <div class="grid-content bg-purple-light">
                                        <div class="infoBox">
                                            <div class="infolabel">cod阈值:</div>
                                            <div class="infoValue">{{ deviceDeatil.codLimit ? deviceDeatil.codLimit :
                                '未设置'
                                                }}
                                            </div>
                                        </div>
                                    </div>
                                </el-col>
                                <el-col :span="6" v-if="projectId !== 'SDjsjc'">
                                    <div class="grid-content bg-purple-light">
                                        <div class="infoBox">
                                            <div class="infolabel">水位阈值:</div>
                                            <div class="infoValue">{{ deviceDeatil.waterLimit ? deviceDeatil.waterLimit
                                :
                                '未设置'
                                                }}</div>
                                        </div>
                                    </div>
                                </el-col>
                            </el-row>
                        </el-main>
                        <el-aside width="200px">
                            <div id="qrCode" ref="qrCodeDiv" class="ercodeCov"></div>
                        </el-aside>
                    </el-container>
                </div>
            </el-card>
            <el-card class="box-card mt10">
                <div slot="header" class="clearfix">
                    <span class="deviceBaseInfoTitle">监测数据</span>
                </div>
                <div class="deviceBaseInfoContent">
                    <el-container>
                        <el-main>
                            <el-row>

                                <el-col :span="4">
                                    <div class="grid-content bg-purple-light">
                                        <div class="infoBox">
                                            <div class="infolabel">电导率:</div>
                                            <div class="infoValue">{{ deviceDeatil.ecValue + ' uS/cm' }}</div>
                                        </div>
                                    </div>
                                </el-col>

                                <el-col :span="4">
                                    <div class="grid-content bg-purple-light">
                                        <div class="infoBox">
                                            <div class="infolabel">测量水位:</div>
                                            <div class="infoValue">{{ deviceDeatil.waterValue + ' m' }}</div>
                                        </div>
                                    </div>
                                </el-col>
                                <el-col :span="7">
                                    <div class="grid-content bg-purple-light">
                                        <div class="infoBox">
                                            <div class="infolabel" style="width: 300px;">标准水位(井深-管长+测量水位+标高) :</div>
                                            <div class="infoValue">{{ deviceDeatil.sWaterValue + ' m' }}</div>
                                        </div>
                                    </div>
                                </el-col>
                                <el-col :span="4" v-if="!hasCOD">
                                    <div class="grid-content bg-purple-light">
                                        <div class="infoBox">
                                            <div class="infolabel">COD:</div>
                                            <div class="infoValue">{{ deviceDeatil.codValue + ' mg/L' }}</div>
                                        </div>
                                    </div>
                                </el-col>
                                <el-col :span="4">
                                    <div class="grid-content bg-purple-light">
                                        <div class="infoBox">
                                            <div class="infolabel">PH:</div>
                                            <div class="infoValue">{{ deviceDeatil.phValue }}</div>
                                        </div>
                                    </div>
                                </el-col>


                            </el-row>
                        </el-main>
                    </el-container>
                </div>
            </el-card>

            <el-card class="box-card mt10">
                <div slot="header" class="clearfix">
                    <span class="deviceBaseInfoTitle">历史属性</span>
                    <div style="float: right" type="text">
                        <el-select v-model="historyProptySearchTag" placeholder="历史属性参数" class="handle-select mr10">
                            <el-option key="5" label="测量水位" value="waterValue"></el-option>
                            <el-option key="6" label="标准水位" value="sWaterValue"></el-option>
                            <el-option key="7" label="电导率" value="ecValue"></el-option>
                            <el-option v-if="!hasCOD" key="8" label="COD" value="codValue"></el-option>
                            <el-option key="9" label="PH" value="phValue"></el-option>
                        </el-select>

                        <!-- @change="historySelectDateChange" -->
                        <el-date-picker v-model="historySelectDate" type="daterange" class="marginLr" align="right"
                            unlink-panels range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"
                            :picker-options="pickerOptions"></el-date-picker>
                        <el-button type="primary" @click="queryHistoryPropty">查询</el-button>
                    </div>
                </div>
                <div>
                    <div class="historyValueBox" ref="historyValue"></div>
                </div>
            </el-card>

            <el-card class="box-card mrt" v-if="companyName == '圣豆电子'">
                <div slot="header" class="clearfix">
                    <span class="deviceBaseInfoTitle">事件信息</span>
                    <div style="float: right; padding: 3px 0" type="text">
                        <el-select v-model="dateSelectValue" placeholder="请选择事件类型" class="marginLr">
                            <el-option key="1" label="设备属性上报" value="1"></el-option>
                            <el-option key="2" label="维护状态更新" value="2"></el-option>
                        </el-select>
                        <el-date-picker v-model="eventDateValue" type="daterange" align="right" unlink-panels
                            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                            :picker-options="pickerOptions"></el-date-picker>
                        <el-button class="ml10" type="primary" @click="eventQuery">查询</el-button>
                    </div>
                </div>
                <div>
                    <div>
                        <el-table :data="tableDatas" border class="table" ref="multipleTable"
                            header-cell-class-name="table-header">
                            <el-table-column prop="time" label="事件时间" width="180" align="center"></el-table-column>
                            <el-table-column prop="type" label="事件类型" width="180" align="center"></el-table-column>
                            <el-table-column prop="content" label="事件内容"></el-table-column>
                        </el-table>
                    </div>
                </div>
            </el-card>
        </div>

        <el-dialog title="修改经纬度信息" :visible.sync="editVisible" width="30%">
            <el-alert title="系统使用的坐标系为GCJ-02坐标系,请务必确认坐标系正确" style="margin-bottom: 10px" type="warning"></el-alert>
            <el-form label-width="70px">
                <el-form-item label="纬度">
                    <el-input v-model="editLongitude" placeholder="请输入纬度"></el-input>
                </el-form-item>
                <el-form-item label="经度">
                    <el-input v-model="editLatitude" placeholder="请输入经度"></el-input>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEditLocation">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 设置阈值弹窗 -->
        <el-dialog :title="limitTitle" :visible.sync="limitVisible" width="30%">
            <el-form label-width="120px">
                <el-form-item :label="limitTitle">
                    <el-input v-if="limitTitle == '设置ph最大值'" type="textarea" autosize v-model="limitValue"
                        placeholder="请输入ph最大值"></el-input>
                    <el-input v-if="limitTitle == '设置ph最小值'" type="textarea" autosize v-model="limitValue"
                        placeholder="请输入ph最小值"></el-input>
                    <el-input v-if="limitTitle == '设置cod阈值'" type="textarea" autosize v-model="limitValue"
                        placeholder="请输入cod阈值"></el-input>
                    <el-input v-if="limitTitle == '设置水位阈值'" type="textarea" autosize v-model="limitValue"
                        placeholder="请输入水位阈值"></el-input>
                    <el-input v-if="limitTitle == '设置ec阈值'" type="textarea" autosize v-model="limitValue"
                        placeholder="请输入ec阈值"></el-input>
                    <el-input v-if="limitTitle == '设置井深'" type="textarea" autosize v-model="limitValue"
                        placeholder="设置井深"></el-input>
                    <el-input v-if="limitTitle == '设置管长'" type="textarea" autosize v-model="limitValue"
                        placeholder="设置管长"></el-input>
                    <el-input v-if="limitTitle == '设置标高'" type="textarea" autosize v-model="limitValue"
                        placeholder="设置标高"></el-input>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button @click="limitVisible = false">取 消</el-button>
                <el-button type="primary" @click="setLimit">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog title="下发工单" :visible.sync="pushTaskVisible" width="30%">
            <el-form label-width="90px">
                <el-form-item label="工单类型" required>
                    <el-select v-model="pushTaskForm.pushType" placeholder="请选择">
                        <el-option label="报警" :value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="工单备注">
                    <el-input type="textarea" autosize v-model="pushTaskForm.pushInfo" placeholder="请输入备注信息"></el-input>
                </el-form-item>
                <el-form-item label="接警人" required>
                    <el-select v-model="pushTaskForm.maintainPeopleId" placeholder="请选择">
                        <el-option v-for="item in maintainUserArr" :key="item.id" :label="item.name"
                            :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button @click="pushTaskVisible = false">取 消</el-button>
                <el-button type="primary" @click="pushTaskF">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {
    GetDeviceDetailProjcet,
    QueryHistoryProptyProject,
    QuerySzjcHistoryEventProject,
    UpdateDeviceLocation,
    ChangeMaintain,
    GetAllMaintainUser,
    AddTask,
    SetLimitSzjc
} from '../../api';
import moment from 'moment';
import QRCode from 'qrcodejs2';
import GCJ02_WGS84 from '@/utils/GCJ02_WGS84.js';
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
import mscard from '@/components/common/dashBoard/msCard.vue';
export default {
    data() {
        return {
            // 下发工单表格
            pushTaskForm: {
                pushType: 1,
                pushInfo: '',
                maintainPeopleId: null
            },
            // 下发工单接警人数组
            maintainUserArr: [],
            // 公司名称
            companyName: JSON.parse(localStorage.getItem('companyInfo')).companyName,
            // 修改经纬度信息
            editVisible: false,

            // 下发工单弹窗
            pushTaskVisible: false,

            // 设置阈值弹窗
            limitVisible: false,
            limitTitle: '',
            limitValue: '',

            editLongitude: '',
            editLatitude: '',
            // 历史搜索标签
            historyProptySearchTag: 'waterValue',
            // 大图预览窗口是否打开
            showImgPriver: false,
            srcList: ['https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg'],
            // 日期快捷选项
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            // 历史属性日期范围值
            historySelectDate: [new Date().getTime() - 3600 * 1000 * 24 * 1, new Date().getTime()],
            // 事件信息日期范围值
            eventDateValue: [new Date().getTime() - 3600 * 1000 * 24 * 1, new Date().getTime()],
            // 设备参数信息
            descArr: [],
            // 设备信息
            deviceDeatil: {},
            dateSelectValue: '1',
            deviceData: {},
            tableDatas: [],
            projectId: '',

            companyId: 1,
            hasCOD: false
        };
    },
    created() {
        this.getData();
        this.companyId = JSON.parse(localStorage.getItem('companyInfo')).companyId

    },
    activated() {
        this.getData();
    },
    computed: {
        // doubleArrDeviceData() {
        //     let result = [];
        //     let arr = [];
        //     // 将获得的设备属性进行数组格式化
        //     this.descArr.forEach(item => {
        //         let obj = {
        //             tag: item[0],
        //             label: item[1],
        //             value: item[2]
        //         };
        //         arr.push(obj);
        //     });
        //     let newArr = [];
        //     arr.forEach((item, index) => {
        //         // 第0项
        //         if (index === 0) {
        //             newArr = [item];
        //         } else if (index == arr.length - 1) {
        //             // 最后一项
        //             newArr.push(item);
        //             result.push(newArr);
        //         } else if (index % 6 !== 0) {
        //             newArr.push(item);
        //         } else {
        //             result.push(newArr);
        //             newArr = [];
        //             newArr.push(item);
        //         }
        //     });
        //     return result;
        // }
    },
    mounted() {
        this.projectId = this.$route.query.projectId
        // this.buildHistoryValueEchart();
        this.getMaintainUser();
    },
    methods: {
        // 获取当前公司的维保人员列表信息
        async getMaintainUser() {
            const result = await GetAllMaintainUser({
                searchTag: 'name',
                searchValue: '%',
                limit: 100,
                offset: 0,
                companyId: JSON.parse(localStorage.getItem('companyInfo')).companyId
            });
            console.log('result');
            console.log(result);
            this.maintainUserArr = result.data.rows.filter((item) => {
                if (item.wxOpenId) {
                    return item;
                }
            });
            console.log(`this.maintainUserArr`);
            console.log(this.maintainUserArr);
        },

        // 切换设备维护状态
        async changeMaintain() {
            this.$confirm('此操作将切换设备维护状态, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(async () => {
                    const result = await ChangeMaintain({
                        projectId: this.$route.query.projectId,
                        deviceName: this.deviceDeatil.deviceName,
                        maintain: this.deviceDeatil.maintain
                    });
                    console.log(result);
                    if (result.code !== 200) {
                        return;
                    }
                    this.getData();
                    this.$message({
                        type: 'success',
                        message: '切换成功!'
                    });
                })
                .catch(() => { });
        },
        // // 确认设置阈值
        async setLimit() {
            console.log(this.limitValue);
            let limitForm = {}
            if (!this.limitValue) {
                this.$message.warning('请输入阈值!');
                return;
            }
            switch (this.limitTitle) {
                case '设置ph最大值':
                    limitForm.limitType = 1
                    break;
                case '设置ph最小值':
                    limitForm.limitType = 2
                    break;
                case '设置cod阈值':
                    limitForm.limitType = 3
                    break;
                case '设置水位阈值':
                    limitForm.limitType = 4
                    break;
                case '设置ec阈值':
                    limitForm.limitType = 5
                    break;
                case '设置井深':
                    limitForm.limitType = 6
                    break;
                case '设置管长':
                    limitForm.limitType = 7
                    break;
                case '设置标高':
                    limitForm.limitType = 8
                    break;
            }
            limitForm.projectId = this.$route.query.projectId;
            limitForm.deviceName = this.deviceDeatil.deviceName;
            limitForm.limitValue = this.limitValue;
            limitForm.createPeopleId = JSON.parse(localStorage.getItem('userinfo')).id;
            limitForm.createCompanyId = JSON.parse(localStorage.getItem('companyInfo')).companyId;
            limitForm.pushTime = new Date().getTime().toString();
            // 设置阈值
            const result = await SetLimitSzjc(limitForm);
            console.log(result);
            this.limitValue = ''
            this.$message.success('设置成功');
            this.limitVisible = false;
        },
        // 确认下发工单
        async pushTaskF() {
            console.log(this.pushTaskForm);
            let pushTaskForm = this.pushTaskForm;
            if (pushTaskForm.maintainPeopleId == null) {
                this.$message.warning('请选择接警人!');
                return;
            }
            if (!pushTaskForm.pushInfo) {
                pushTaskForm.pushInfo = '无';
            }
            pushTaskForm.projectId = this.$route.query.projectId;
            pushTaskForm.deviceName = this.deviceDeatil.deviceName;
            pushTaskForm.createPeopleId = JSON.parse(localStorage.getItem('userinfo')).id;
            pushTaskForm.createCompanyId = JSON.parse(localStorage.getItem('companyInfo')).companyId;
            pushTaskForm.pushTime = new Date().getTime().toString();
            this.$confirm('此操作将向接警人员派发工单,是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(async () => {
                    // 派发工单
                    const result = await AddTask(pushTaskForm);
                    console.log(result);
                    this.pushTaskForm = {
                        pushType: 1,
                        pushInfo: '',
                        maintainPeopleId: null
                    };
                    this.$message.success('下发成功');
                    this.pushTaskVisible = false;
                })
                .catch(() => { });
        },
        // 打开编辑位置弹窗
        async editLocationF() {
            console.log(this.deviceDeatil);
            this.editVisible = true;
            this.editLongitude = this.deviceDeatil.longitude;
            this.editLatitude = this.deviceDeatil.latitude;
        },
        // 保存编辑值
        async saveEditLocation() {
            const result = await UpdateDeviceLocation({
                id: this.deviceDeatil.id,
                longitude: this.editLongitude,
                latitude: this.editLatitude,
                projectId: this.$route.query.projectId
            });
            if (result.code !== 200) {
                return;
            }
            this.$message.success('修改成功');
            this.editVisible = false;
            this.getData();
        },
        // 查询事件信息
        async eventQuery() {
            let startTime = new Date(this.eventDateValue[0]).getTime();
            let endTime = new Date(this.eventDateValue[1]).getTime();
            const result = await QuerySzjcHistoryEventProject({
                projectId: this.$route.query.projectId,
                deviceName: this.deviceDeatil.deviceName,
                dateSelectValue: this.dateSelectValue,
                startTime: startTime,
                endTime: endTime
            });
            if (result.code !== 200) {
                return;
            }
            let dataArr = [];
            result.data.forEach((item) => {
                let obj = {};
                obj.time = moment(item.createTime * 1).format('MM-DD HH:mm:ss');
                let contentValue = {};
                switch (this.dateSelectValue) {
                    case '1':
                        obj.type = '设备属性上报';
                        for (const key in item) {
                            if (item[key] !== null) {
                                contentValue[key] = item[key];
                            }
                        }
                        obj.content = JSON.stringify(contentValue);
                        dataArr.push(obj);
                        break;

                    case '2':
                        obj.type = '维护状态更新';
                        for (const key in item) {
                            if (key == 'type') {
                                if (item[key] == '0') {
                                    obj.type = '维护状态更新-解除维护';
                                } else if (item[key] == '1') {
                                    obj.type = '维护状态更新-加入维护';
                                }
                            }
                            if (item[key] !== null) {
                                contentValue[key] = item[key];
                            }
                        }
                        obj.content = JSON.stringify(contentValue);
                        dataArr.push(obj);
                        break;
                    case '3':
                        obj.type = 'PH上报';
                        for (const key in item) {
                            if (item[key] !== null) {
                                contentValue[key] = item[key];
                            }
                        }
                        obj.content = JSON.stringify(contentValue);
                        dataArr.push(obj);
                        break;
                    case '4':
                        obj.type = '液位值上报';
                        for (const key in item) {
                            if (item[key] !== null) {
                                contentValue[key] = item[key];
                            }
                        }
                        obj.content = JSON.stringify(contentValue);
                        dataArr.push(obj);
                        break;
                    case '5':
                        obj.type = 'COD上报';
                        for (const key in item) {
                            if (item[key] !== null) {
                                contentValue[key] = item[key];
                            }
                        }
                        obj.content = JSON.stringify(contentValue);
                        dataArr.push(obj);
                        break;
                    case '6':
                        obj.type = 'EC上报';
                        for (const key in item) {
                            if (item[key] !== null) {
                                contentValue[key] = item[key];
                            }
                        }
                        obj.content = JSON.stringify(contentValue);
                        dataArr.push(obj);
                        break;
                    default:
                        break;
                }
            });
            this.tableDatas = dataArr;
            console.log(this.tableDatas, 'this.tableDatas');
            console.log(result);

            // let startTime = new Date(this.historySelectDate[0]).getTime();
            // let endTime = new Date(this.historySelectDate[1]).getTime();
            // const result = await QueryHistoryProptyProject({
            //     projectId: this.$route.query.projectId,
            //     deviceName: this.deviceDeatil.deviceName,
            //     historyProptySearchTag: this.historyProptySearchTag,
            //     startTime: startTime,
            //     endTime: endTime
            // });
        },
        // 历史属性查询
        async queryHistoryPropty() {
            let startTime = new Date(this.historySelectDate[0]).getTime();
            let endTime = new Date(this.historySelectDate[1]).getTime();
            const result = await QueryHistoryProptyProject({
                projectId: this.$route.query.projectId,
                deviceName: this.deviceDeatil.deviceName,
                historyProptySearchTag: this.historyProptySearchTag,
                startTime: startTime,
                endTime: endTime
            });
            if (result.code !== 200) {
                return;
            }

            // 定义单位物模型
            let unitObj = [
                { name: 'waterValue', unit: 'm' },
                { name: 'sWaterValue', unit: 'm' },
                { name: 'codValue', unit: 'mg/L' },
                { name: 'ecValue', unit: 'uS/cm' },
                { name: 'phValue', unit: '' },
            ];
            let unit = null;
            // 设置单位
            unitObj.forEach((item) => {
                if (item.name == this.historyProptySearchTag) {
                    unit = item.unit;
                }
            });

            // 循环设置曲线图所需数据
            let xData = [];
            let yData = [];
            let yAxisType = 'value';
            if (this.historyProptySearchTag == 'openStatus') {
                yAxisType = 'category';
            }
            result.data.forEach((item, index) => {
                xData.push(moment(item.createTime * 1).format('MM-DD HH:mm:ss'));

                // 判断是否开启状态
                if (this.historyProptySearchTag == 'openStatus') {
                    yData.push(item[this.historyProptySearchTag] ? '打开' : '关闭');
                } else {
                    yData.push(item[this.historyProptySearchTag] * 1);
                }
            });
            this.buildHistoryValueEchart(xData, yData, yAxisType, unit);
            console.log('++++++++++++++++++++');
            console.log(result);
        },

        // 获取设备数据
        async getData() {
            // 判断是否有合法参数
            console.log(!this.$route.query.projectId);
            console.log(!this.$route.query.deviceId);

            if (!this.$route.query.projectId || !this.$route.query.deviceId) {
                this.$router.go(-1);
                this.$message.error('参数不完整');
                return;
            }

            const result = await GetDeviceDetailProjcet({
                projectId: this.$route.query.projectId,
                deviceId: this.$route.query.deviceId
            });
            console.log(result, '-------');
            if (result.code !== 200) {
                return;
            }
            let data = result.data;

            data.createtime = moment(data.createTime * 1).format('YYYY-MM-DD HH:mm:ss');
            data.updatetime = moment(data.updateTime * 1).format('YYYY-MM-DD HH:mm:ss');
            if (data.deviceNo == '03A0572AE0N7S40S' || data.deviceNo == '74580F5E532252FK' || data.deviceNo == '79A632Q1R5U20980' || data.deviceNo == '74AP5916045Z8VSP' || data.deviceNo == 'KEPF6F04B2E110HZ' || data.deviceNo == '6VX5H9D513415CM5') {
                this.hasCOD = true
            }
            let that = this;
            that.deviceDeatil = data;
            that.deviceDeatil.locationText = result.county + result.address;
            that.erCodeBtn();
            that.queryHistoryPropty();
            that.eventQuery();
            return;
        },

        // 查看大图
        showImgPriverFunc() {
            if (!this.deviceDeatil.imgSrc) {
                this.$message.warning('该设备没有图片');
                return;
            } else {
                this.showImgPriver = true;
            }
        },
        // 关闭大图
        hidImgPriverFunc() {
            this.showImgPriver = false;
        },
        //  设备属性历史曲线图标生成
        buildHistoryValueEchart(xData, yData, yAxisType, unit) {
            console.log(unit);
            console.log(xData, yData, yAxisType, unit, '------------');

            let historyValue = this.$echarts.init(this.$refs.historyValue);
            historyValue.setOption({
                grid: {
                    bottom: 25,
                    top: 80,
                    left: 80,
                    right: 80
                },
                xAxis: {
                    type: 'category',
                    data: xData,
                    name: '时间'
                },
                tooltip: {
                    trigger: 'axis',
                    type: 'cross'
                    // formatter: `{b0}<br /> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{c0} ${unit}`
                },
                yAxis: {
                    type: yAxisType,
                    name: `单位: ${unit ? unit : '无'}`
                },
                series: [
                    {
                        data: yData,
                        type: 'line',
                        showSymbol: false,
                        lineStyle: {
                            normal: {
                                width: 1,
                                color: 'rgb(0, 221, 255)' // 线条颜色
                            },
                            borderColor: 'rgba(0,0,0,.4)'
                        },
                        itemStyle: {
                            color: 'rgba(24,187,157,1)',
                            borderColor: '#646ace',
                            borderWidth: 1
                        },
                        tooltip: {
                            show: true
                        },
                        areaStyle: {
                            //区域填充样式
                            normal: {
                                //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                                color: new this.$echarts.graphic.LinearGradient(
                                    0,
                                    0,
                                    0,
                                    1,
                                    [
                                        {
                                            offset: 0,
                                            color: 'rgb(0, 221, 255)'
                                        },
                                        {
                                            offset: 1,
                                            color: 'rgb(77, 119, 255)'
                                        }
                                    ],
                                    false
                                ),
                                shadowColor: 'rgba(10,219,250, 0.5)', //阴影颜色
                                shadowBlur: 2 //shadowBlur设图形阴影的模糊大小。配合shadowColor,shadowOffsetX/Y, 设置图形的阴影效果。
                            }
                        }
                    }
                ]
            });
        },

        // 生成设备二维码
        erCodeBtn() {
            this.$nextTick(function () {
                let text = JSON.stringify({
                    deviceName: this.deviceDeatil.deviceName,
                    projectId: this.$route.query.projectId
                });

                document.getElementById('qrCode').innerHTML = '';
                new QRCode(this.$refs.qrCodeDiv, {
                    text: text,
                    width: 150,
                    height: 150,
                    colorDark: '#333333', //二维码颜色
                    colorLight: '#ffffff', //二维码背景色
                    correctLevel: QRCode.CorrectLevel.H //容错率，L/M/H
                });
            });
        },

        // 每日设备状态折线图数据处理
        beforDeviceDataComputerLine() {
            let arr = this.$store.state.deviceBefore;
            let xData = arr.map((item) => {
                return item.date;
            });
            let vSeries = [];
            // let normalObj = {};
            // let alarmObj = {};
            // let trouleObj = {};
            let normalDataArr = [];
            let alarmDataArr = [];
            let trouleDataArr = [];
            this.$store.state.deviceBefore.forEach((item) => {
                normalDataArr.push(item.normal);
                alarmDataArr.push(item.alarm);
                trouleDataArr.push(item.troule);
            });
            // vSeries.push(normalObj,alarmObj,trouleObj)

            vSeries.push({
                name: '正常',
                type: 'line',
                itemStyle: {
                    color: '#08d97b'
                },
                data: normalDataArr
            });

            vSeries.push({
                name: '报警',
                type: 'line',
                itemStyle: {
                    color: '#e83c03'
                },
                data: alarmDataArr
            });
            vSeries.push({
                name: '故障',
                type: 'line',
                itemStyle: {
                    color: '#ff8115'
                },
                data: trouleDataArr
            });

            console.log('vSeries');
            console.log(vSeries);

            return {
                xData,
                vSeries
            };
        }
    },
    components: {
        ElImageViewer,
        mscard
    }
};
</script>



<style scoped lang="less">
@import '../../assets/css/variables.less';

// 修改elcard ---开始---
/deep/ .el-card__header {
    background-color: #1c1c24;
    color: #fff;
}

/deep/ .el-card__body,
.el-main {
    background-color: #1c1c24;
}

/deep/ .el-card {
    border: none;
    background-color: transparent;
}

/deep/ .el-card__header {
    border-bottom: none;
}

// 修改elcard ---结束---
// 修改弹窗样式 ---开始--
/deep/ .el-dialog__header {
    background-color: @black-two;
    color: #fff;
}

/deep/ .el-dialog__title {
    color: #fff;
}

/deep/ .el-dialog__body {
    background-color: @black-two;
    color: #fff;
}

/deep/ .el-dialog__footer {
    background-color: @black-two;
    color: #fff;
}

/deep/ .el-table th {
    background-color: @black-two !important;
    color: @gray-one;
}

/deep/ .el-table tr {
    background-color: @black-two;
    color: #fff;
}

/deep/ .el-table tr:hover {
    background: @black-three !important;
}

/deep/ .el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell {
    background: none;
}

/deep/ .el-table__empty-block {
    background-color: @black-two;

    border: none;
}

/deep/ .el-table__empty-text {
    color: #fff;
}

/deep/ .el-button--text {
    color: @gray-one;
}

/deep/ .el-button--text:hover {
    color: #fff;
}

/deep/ .el-button--primary {
    background-color: #fff;
    color: @black-three;
    border: none;
}

/deep/ .el-button--primary:hover {
    background-color: @black-two;
    color: #fff;
    border: none;
    transition: all 0.5s;
}

/deep/ .el-dialog__headerbtn .el-dialog__close:hover {
    color: #fff;
}

/deep/ .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
    border: none !important;
}

// 修改弹窗样式 ---结束--

.deviceBaseInfoTitle {
    font-size: 0.5rem;
}

.deviceBaseInfoContent {
    .infoBox {
        display: flex;
        font-size: 15px;
        margin: 10px 0;
        align-items: center;

        .infolabel {
            color: #aeb0b3;
            margin-right: 5px;
            width: 140px;
            text-align: right;
        }

        .infoValue {
            color: #fff;
        }
    }
}

.deviceValueInfoContent {
    font-size: 17px;
    margin: 10px;

    .box-card {
        margin: 10px 0;
    }

    .infolabel {
        color: #909399;
        text-align: center;
    }

    .infoValue {
        text-align: center;
        margin-top: 10px;
    }
}

.el-tag.el-tag--success {
    color: #ffffff;
}

.margin-top {
    margin-top: 10px;
}

.detaFilter {
    margin-top: -30px;
    margin-bottom: 10px;
}

.marginLr {
    margin-left: 10px;
    margin-right: 10px;
}

.one {
    width: 100%;
    height: 400px;
}

.llll {
    margin-left: 10px;
}

.ercodeCov {
    width: 200px;
    max-width: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.mrt {
    margin-top: 20px;
}

.historyValueBox {
    width: 100%;
    height: 400px;
}

.curson {
    cursor: pointer;
}

.deviceImg {
    width: 50px;
    height: 50px;
}

.mt10 {
    margin-top: 10px;
}

.el-card__header {
    padding: 0px 20px;
}

.ml10 {
    margin-left: 10px;
}
</style>